import { ar } from './ar.js';
import { bn } from './bn.js';
import { es } from './es.js';
import { fa } from './fa.js';
import { fr } from './fr.js';
import { gu } from './gu.js';
import { it } from './it.js';
import { pa } from './pa.js';
import { pl } from './pl.js';
import { pt } from './pt.js';
import { ro } from './ro.js';
import { so } from './so.js';
import { tl } from './tl.js';
import { tr } from './tr.js';
import { ur } from './ur.js';
import { zh } from './zh.js';
import { applyJourneyExplanationSafetyCorrections } from '../journeyExplanationSafetyCorrections.js';
import { overrideJourneyExplanation } from '../professionalTranslationRuntime.js';
import { getJourneyExplanationTranslationBatch2 } from '../journeyExplanationTranslationsBatch2/index.js';
import { getJourneyExplanationTranslationBatch3 } from '../journeyExplanationTranslationsBatch3/index.js';
import { getJourneyExplanationTranslationBatch4 } from '../journeyExplanationTranslationsBatch4/index.js';
import { getJourneyExplanationTranslationBatch5 } from '../journeyExplanationTranslationsBatch5/index.js';
import { getJourneyExplanationTranslationBatch6 } from '../journeyExplanationTranslationsBatch6/index.js';
import { getJourneyExplanationTranslationBatch7 } from '../journeyExplanationTranslationsBatch7/index.js';
import { getJourneyExplanationTranslationBatch8 } from '../journeyExplanationTranslationsBatch8/index.js';

export const JOURNEY_EXPLANATION_TRANSLATIONS = Object.freeze({ ar, bn, es, fa, fr, gu, it, pa, pl, pt, ro, so, tl, tr, ur, zh });

export function getJourneyExplanationTranslation(language, journeyId, stageId) {
  const normalizedLanguage = String(language || '').toLowerCase().split('-')[0];
  const templateId = String(journeyId || '').replace(/^generic-/, '');
  const base = getJourneyExplanationTranslationBatch8(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch7(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch6(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch5(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch4(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch3(normalizedLanguage, templateId, stageId)
    || getJourneyExplanationTranslationBatch2(normalizedLanguage, templateId, stageId)
    || JOURNEY_EXPLANATION_TRANSLATIONS[normalizedLanguage]?.[templateId]?.[stageId]
    || null;
  const corrected = applyJourneyExplanationSafetyCorrections(normalizedLanguage, templateId, stageId, base);
  return overrideJourneyExplanation(normalizedLanguage, templateId, stageId, corrected);
}
